import { STORAGE_TOKEN } from "../../constants/localstorage";
import { logIn } from "../../libs/auth";
import { setStorage } from "../../libs/storage";
import { UserTwoStepVerificationRecoverPasswordByAnswersResponse } from "../../proto/UserTwoStepVerificationRecoverPasswordByAnswers_pb";
import BaseHandler from "../BaseHandler";

export default class HandleUserTwoStepVerificationRecoverPasswordByAnswersResponse extends BaseHandler<UserTwoStepVerificationRecoverPasswordByAnswersResponse> {
  handle() {
    const userTwoStepVerificationRecoverPasswordByAnswersResponse = this.response.toObject();
    setStorage(STORAGE_TOKEN, userTwoStepVerificationRecoverPasswordByAnswersResponse.token);
    logIn();
  }
}
